const requiredEnvFields = ['oneInchDevPortalHost', 'walletConnectProjectId'];
const env = {
    oneInchDevPortalHost: 'https://api.1inch.dev',
};
let embeddedMode = false;
/**
 * @deprecated
 * */
export function getEnvironmentValue(valueName) {
    if (embeddedMode && env[valueName] === undefined && requiredEnvFields.includes(valueName)) {
        throw new Error(`environment value ${valueName} not exist`);
    }
    return env[valueName];
}
export function setEnvironmentValue(valueName, value) {
    env[valueName] = value;
}
export function enabledEmbeddedMode() {
    embeddedMode = true;
}
//# sourceMappingURL=get-environment-value.js.map